export const GOOGLE_SHOPPING_ROUTES = {
    ROOT_GENERAL: "google",
    ROOT_INFO: "shopping",
    ROOT_GSH_CONNECTED: "connect-shopping",
  };